<div class="appo-no-available-dates-dialog">
  <si-generic-dialog [(displayDialog)]="displayDialog"
                     (displayDialogChange)="onVisibleChange($event)"
                     dialogSizeClass="si-dialog-medium"
                     [closable]="false"
                     dialogTitle="SI_UPS"
                     dialogTitleStyleClass="appo-no-available-dates-dialog_title mb-1"
                     dialogImg="assets/images/calendar.svg"
                     [dialogText]="dialogText"
                     [button1Text]="showAppoRequestBackButton ? 'SI_APPOINTMENT_REQUEST_BACK' : ''"
                     button1Class="si-button_main"
                     (updateButton1Change)="onClickCloseDialog(true)"
                     [button2Text]="showRequestAppointmentButton ? 'SI_REGISTER_REQUEST' : ''"
                     button2Class="si-button_green"
                     (updateButton2Change)="onClickButtonRegisterRequest()"
                     [button3Text]="(null | siExternalReference) ? '' : 'SI_EXIT'"
                     button3Class="si-button_cancel"
                     (updateButton3Change)="onClickCloseDialog(false)"
                     [isScrollable]="true"
  ></si-generic-dialog>
</div>

